import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import axios from 'axios';

import './index.css';
import 'swiper/swiper-bundle.css';
import 'flatpickr/dist/flatpickr.css';

import { store, persistor } from './store';

// Intercepteur global : token expiré ou invalide → reset du store + redirection
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.dispatch({ type: 'RESET_STORE' });
      persistor.purge();
      localStorage.removeItem('user');
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AppWrapper } from './components/common/PageMeta';

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container #root not found");
}

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <Provider store={store}>
        <PersistGate loading={<h1>Loading...</h1>} persistor={persistor}>
          <Suspense fallback={<p>...</p>}>
            <AppWrapper>
              <App />
            </AppWrapper>
          </Suspense>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </StrictMode>
);
